import { useMemo } from "react"

import { CACHE_PROFILES } from "@/config/query-cache"
import { useTransportQuery } from "@/transport"

import type { GetMetricLabelsRequest } from "@/types_api/backend/transport/get_metric_labels_request"
import type { MetricLabelResource } from "@/types_api/backend/transport/get_metric_labels_response"

const MAX_METRIC_LABEL_IDS = 10

export function useMetricLabelsTransport(metricIds: string[]) {
  const request = useMemo<GetMetricLabelsRequest | undefined>(() => {
    const normalizedIds = Array.from(
      new Set(metricIds.map((id) => id.trim()).filter(Boolean)),
    ).slice(0, MAX_METRIC_LABEL_IDS)
    return normalizedIds.length > 0
      ? { metric_ids: normalizedIds as [string, ...string[]] }
      : undefined
  }, [metricIds])

  return useTransportQuery<
    "getMetricLabels",
    Record<string, MetricLabelResource>
  >({
    operation: "getMetricLabels",
    request,
    options: {
      ...CACHE_PROFILES.lookup,
      enabled: request !== undefined,
      select: (response) => response.metrics_by_id ?? {},
    },
  })
}
